import Header from "@/components/Header";
import Footer from "@/components/Footer";
import TestimonialsSection from "@/components/TestimonialsSection";

export default function Testimonials() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-950 flex flex-col" data-testid="testimonials-page">
      <Header />
      <main className="flex-1 max-w-7xl mx-auto w-full px-6 lg:px-10 py-16 sm:py-24">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-[11px] uppercase tracking-[0.18em] text-teal-700 dark:text-teal-400">Proof</p>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl font-semibold text-slate-900 dark:text-slate-50 tracking-tight">
            What operators say
          </h1>
          <p className="mt-4 text-base text-slate-600 dark:text-slate-300 leading-relaxed">
            Real feedback from solopreneurs, SMEs and departments who ran the Biz Resilience Scan.
            Some chose to stay anonymous — every quote is shared with consent.
          </p>
        </div>
        <div className="mt-14">
          <TestimonialsSection surface="testimonials" bare heading="" />
        </div>
      </main>
      <Footer />
    </div>
  );
}
